<template>
  <div class="asc-file-upload-errors">
    <asc-validation-error
      v-for="(item, index) in items"
      :key="index"
      class="asc-loading-error"
      :value="item.message"
      :file="item.file ? item.file : null"
      :retry-enabled="!!item.file"
      @cancelFileUpload="handleCancelFromError"
      @handleRetryUpload="handleRetryUpload"
    ></asc-validation-error>
  </div>
</template>

<script>
import AscValidationError from '@/components/atoms/AscValidationError'
import variables from '@/styles/_varsJs.scss'

export default {
  name: 'AscFileUploadErrors',

  components: {
    AscValidationError,
  },

  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    getErrorColor() {
      return variables.warningbase
    },
  },

  methods: {
    handleCancelFromError(file) {
      this.$emit('cancelFileUpload', file)
    },
    handleRetryUpload(file) {
      this.$emit('retryFileUpload', file)
    },
  },
}
</script>

<style lang="scss">
.asc-loading-error {
  margin-top: 8px;
  border: 2px solid $warning-base;
  padding: 8px;
  min-width: 260px;
}
</style>
